module.exports = __webpack_public_path__ + "img/payment.519518a8.webp";